import { Box, Button, Dialog, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import ASubAdmin from '../../../models/Admin/ASubAdmin';
import { useAppDispatch } from '../../../store';
import aAdminsAsyncActions from '../../../store/actions/aAdmins.action';
import { useAServersState, useRequestState } from '../../../store/selectors';
import theme from '../../../theme';
import { createSubAdmin, updateSubAdmin } from 'api-services/sub-admin';

const useStyles = makeStyles({
	root: {
		'& .MuiPaper-root': {
			backgroundColor: '#f1f1f1',
		},
	},
	container: {
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
	},
});
export interface Props {
	user?: ASubAdmin | null;
	open: boolean;
	onClose: () => void;
}
const CreateSubAdminModal: React.FC<Props> = ({ user, open, onClose }) => {
	const classes = useStyles();

	const dispatch = useAppDispatch();
	const aServersState = useAServersState();

	const [firstName, setFirstName] = React.useState<string>('');
	const [lastName, setLastName] = React.useState<string>('');
	const [username, setUsername] = React.useState<string>('');
	const [password, setPassword] = React.useState<string>('');
	const [serverId, setServerId] = React.useState<string>('');

	React.useEffect(() => {
		if (!open || !user) {
			return;
		}

		setFirstName(user.firstName ?? '');
		setLastName(user.lastName ?? '');
		setUsername(user.username);
		setServerId(user.serverId.toString());
	}, [open]);

	return (
		<Dialog className={classes.root} open={open} fullWidth maxWidth="sm">
			<Box flex={1} padding={'2em'}>
				<Grid spacing={2} container>
					<Grid item xs={12} sm={12} md={6}>
						<FormControl fullWidth>
							<InputLabel id="demo-simple-select-label">Server</InputLabel>
							<Select
								classes={{
									select: classes.container,
								}}
								labelId="demo-simple-select-label"
								id="demo-simple-select"
								value={serverId}
								label="Server"
								onChange={(e) => setServerId(e.target.value)}
							>
								{aServersState.list.map((element) => (
									<MenuItem key={element.id} value={element.id}>
										{element.name}
									</MenuItem>
								))}
							</Select>
						</FormControl>
					</Grid>
					<Grid item xs={12} sm={12} md={6}>
						<TextField
							label={'First Name'}
							value={firstName}
							onChange={(e) => setFirstName(e.target.value)}
							fullWidth
							size="small"
							variant="outlined"
						/>
					</Grid>
					<Grid item xs={12} sm={12} md={6}>
						<TextField
							label={'Last Name'}
							value={lastName}
							onChange={(e) => setLastName(e.target.value)}
							fullWidth
							size="small"
							variant="outlined"
						/>
					</Grid>
					<Grid item xs={12} sm={12} md={6}>
						<TextField
							label={'Username'}
							value={username}
							onChange={(e) => setUsername(e.target.value)}
							fullWidth
							size="small"
							variant="outlined"
						/>
					</Grid>
					<Grid item xs={12} sm={12} md={6}>
						<TextField
							label={'Password'}
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							fullWidth
							type={'password'}
							size="small"
							variant="outlined"
						/>
					</Grid>
				</Grid>
				<Box height={48} />
				<Grid spacing={2} container>
					<Grid item xs={6} sm={6} md={3}>
						<Button
							onClick={async () => {
								if (user) {
									await updateSubAdmin(user.id, {
										password,
										serverId: parseInt(serverId),
										username,
										firstName,
										lastName,
									});
								} else {
									await createSubAdmin({
										password,
										serverId: parseInt(serverId),
										username,
										firstName,
										lastName,
									});
								}
								onClose();
							}}
							sx={{ height: '40px' }}
							fullWidth
							variant="contained"
						>
							Save
						</Button>
					</Grid>
					<Grid item xs={6} sm={6} md={3}>
						<Button sx={{ height: '40px' }} onClick={onClose} fullWidth variant="outlined">
							Cancel
						</Button>
					</Grid>
				</Grid>
			</Box>
		</Dialog>
	);
};

export default CreateSubAdminModal;
